import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Hero, Skills, Experience, Projects, Testimonials, Contact } from '../components';
import { scrollOffset } from '../utils/scrollOffset';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      const offset = scrollOffset(location.hash);

      if (el) {
        window.scrollTo({
          behavior: 'smooth',
          top: el.getBoundingClientRect().top + window.scrollY + offset,
        });
      }
    }
  }, []);

  return (
    <>
      <Hero />
      <Skills />
      <Experience />
      <Projects />
      <Testimonials />
      <Contact />
    </>
  );
};

export default HomePage;
